import { createSlice } from "@reduxjs/toolkit";

const copyAssistantSlice = createSlice({
  name: "copyAssistant",
  initialState: {
    shouldRefreshSentences: false,
  },
  reducers: {
    setShouldRefreshSentences: (state, action) => {
      state.shouldRefreshSentences = action.payload;
    },
  },
});

export const { setShouldRefreshSentences } = copyAssistantSlice.actions;
export default copyAssistantSlice.reducer;
